import { ValidationRules } from 'helpers/createFormConfig';
import { naturalPersonValidationRules } from 'features/new-actor/form/validation-rules/naturalPersonValidationRules';
import {
  borrowerBaseValidationRules,
  BorrowerNaturalFormValues
} from '../borrowerInsuredForm';

export const borrowerNaturalPersonValidationRules: ValidationRules<
  Exclude<keyof BorrowerNaturalFormValues, 'id'>
> = {
  ...naturalPersonValidationRules,
  ...borrowerBaseValidationRules
};
